export default __webpack_public_path__ + "static/media/ownership_structure_02.732c3f15.png";